import { trackEvent } from '@/common/telemetry';
import useComputeProvisioningStore from '@/common/store/pinia/computeProvisioning';

export type ProvisioningOutcome = 'completed' | 'failed';

type ReportedTask = {
  task_id: ID;
  revision_id?: ID;
};

export const readProvisioningOperationId = (): string | null => useComputeProvisioningStore().operationId;

export const ensureProvisioningOperationId = (): string => useComputeProvisioningStore().ensureProvisioningOperationId();

export const recordStepEntered = (stepName: string) => useComputeProvisioningStore().recordStepEntered(stepName);

export const secondsOnStep = (): number | null => {
  const { stepTrailEnteredAt } = useComputeProvisioningStore();
  return stepTrailEnteredAt ? Math.round((Date.now() - stepTrailEnteredAt) / 1000) : null;
};

export const clearProvisioningTimer = (): void => useComputeProvisioningStore().clearProvisioningTimer();

export const trackProvisioning = (action: string, properties: Record<string, unknown> = {}): void => {
  const { startedAt, operationId } = useComputeProvisioningStore();

  trackEvent('compute_provisioning', {
    action,
    operationId,
    secondsSinceStart: startedAt ? Math.round((Date.now() - startedAt) / 1000) : null,
    ...properties
  });
};

const outcomeKey = (outcome: ProvisioningOutcome, task: ReportedTask): string => (
  `${task.task_id}:${task.revision_id ?? ''}:${outcome}`
);

export const trackProvisioningOutcome = (
  outcome: ProvisioningOutcome,
  task: ReportedTask | null | undefined,
  properties: Record<string, unknown> = {}
): boolean => {
  const computeProvisioningStore = useComputeProvisioningStore();
  const key = task ? outcomeKey(outcome, task) : null;
  if (key && computeProvisioningStore.reportedOutcome === key) {
    return false;
  }
  trackProvisioning(outcome, {
    taskId: task?.task_id ?? null,
    revisionId: task?.revision_id ?? null,
    ...properties
  });
  if (key) {
    computeProvisioningStore.reportedOutcome = key;
  }
  return true;
};
